import { AISettings } from "./AISettings";

import { CloseOverlayButton } from "components/materials/sidebar/CloseOverlayButton";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectCurrentUserIsMPAdmin } from "store/selectors";
import { aiStateActions } from "store/slices/ai";

export const AIChatToolbar = () => {
  const isMPAdmin = useAppSelector(selectCurrentUserIsMPAdmin);
  const dispatch = useAppDispatch();

  return (
    <div className="flex items-center justify-end gap-2">
      {isMPAdmin && <AISettings />}

      <SquareButton
        eventName="AI Assistant - Clear chat"
        kind="tertiary"
        size="s"
        onClick={() => dispatch(aiStateActions.clearAiChatMessages())}
      >
        {t("ai.clear_chat")}
      </SquareButton>

      <CloseOverlayButton />
    </div>
  );
};
